import { WithPaginationMetaResponse } from "../../../types";

interface GetSwrInifiniteKeyParams {
  path: string;
  limit?: number;
}

export function getSwrInfiniteKey<T>({
  path,
  limit = 30,
}: GetSwrInifiniteKeyParams) {
  const getKey = (
    pageIndex: number,
    previousPageData: WithPaginationMetaResponse<T>
  ) => {
    const isLastPage =
      previousPageData && previousPageData.meta.totalPages === pageIndex + 1;

    if (isLastPage) return null;

    return `/${path}?page=${pageIndex}&limit=${limit}`;
  };

  return getKey;
}
